export const ULATEK_ENCOUNTER_ID = 3492;
export const ULATEK_BOSS_SLUG = 'ulatek';

// Set this to true to fall back to unencoded boss health without removing phase-event collection.
export const ULATEK_USE_SIMPLE_BOSS_HEALTH = false;

export const ULATEK_RAGE_OF_THE_SHACKLED_SPELL_ID = 1286860;
export const ULATEK_CALL_OF_THE_SERPENT_SPELL_ID = 1300751;
export const ULATEK_VENOMOUS_HEART_SPELL_ID = 1299526;

export const ULATEK_CAST_SUCCESS_EVENT_SOURCE = 1;
export const ULATEK_AURA_APPLIED_EVENT_SOURCE = 2;
export const ULATEK_AURA_REMOVED_EVENT_SOURCE = 3;

export type TUlatekPhase = 'p1' | 'p2' | 'i2' | 'p3';

export type TUlatekPhaseEvent = {
  occurredAt: Date;
  spellId: number | null;
  eventSource: number | null;
};

export const ULATEK_PHASE_BANDS: Record<TUlatekPhase, { min: number; max: number }> = {
  p1: { min: 0.75, max: 1 },
  p2: { min: 0.5, max: 0.75 },
  i2: { min: 0.25, max: 0.5 },
  p3: { min: 0, max: 0.25 }
};

const ULATEK_PHASE_DIFFICULTIES = new Set(['normal', 'heroic', 'mythic']);

export function isUlatekPhaseTrackingDifficulty(difficulty: string): boolean {
  return ULATEK_PHASE_DIFFICULTIES.has(difficulty);
}

export function getUlatekPhase(events: TUlatekPhaseEvent[]): TUlatekPhase {
  const reachedPhaseThree = events.some(
    (event) =>
      event.spellId === ULATEK_CALL_OF_THE_SERPENT_SPELL_ID && event.eventSource === ULATEK_CAST_SUCCESS_EVENT_SOURCE
  );
  if (reachedPhaseThree) {
    return 'p3';
  }

  const firstHeartRemoval = events
    .filter(
      (event) =>
        event.spellId === ULATEK_VENOMOUS_HEART_SPELL_ID && event.eventSource === ULATEK_AURA_REMOVED_EVENT_SOURCE
    )
    .sort((left, right) => left.occurredAt.getTime() - right.occurredAt.getTime())[0];
  if (!firstHeartRemoval) {
    return 'p1';
  }

  const intermissionStarted = events.some(
    (event) =>
      event.spellId === ULATEK_VENOMOUS_HEART_SPELL_ID &&
      event.eventSource === ULATEK_AURA_APPLIED_EVENT_SOURCE &&
      event.occurredAt.getTime() > firstHeartRemoval.occurredAt.getTime()
  );

  return intermissionStarted ? 'i2' : 'p2';
}

export function encodeUlatekPhaseProgress(phase: TUlatekPhase, phasePercent: number): number {
  const band = ULATEK_PHASE_BANDS[phase];
  const clampedPhasePercent = Math.max(0, Math.min(1, phasePercent));
  const encoded = band.min + clampedPhasePercent * (band.max - band.min);
  return phase === 'p3' ? encoded : Math.max(band.min + Number.EPSILON, encoded);
}
